import { SxProps, Theme } from '@mui/material';

const statusChipColors: Record<string, { backgroundColor: string; color: string }> = {
  INCOMPLETE: { backgroundColor: '#EC902F', color: '#ffffff' },
  DENIED: { backgroundColor: '#DF3A35', color: '#ffffff' },
  PAID: { backgroundColor: '#68A84C', color: '#ffffff' },
  APPROVED: { backgroundColor: '#C4D545', color: '#000000' },
  SUBMITTED: { backgroundColor: '#EBE244', color: '#000000' },
  PENDING_REVIEW: { backgroundColor: '#EBB1A2', color: '#000000' },
  LEGAL_MEDIATION: { backgroundColor: '#783D8B', color: '#ffffff' },
  WITH_OPERATIONS: { backgroundColor: '#783D8B', color: '#ffffff' },
  CLOSED: { backgroundColor: '#795548', color: '#ffffff' },
};

export const getStatusChipSx = (status: string, extra?: SxProps<Theme>): SxProps<Theme> => {
  const colors = statusChipColors[status];
  if (!colors) {
    return extra ?? {};
  }

  return {
    backgroundColor: colors.backgroundColor,
    color: colors.color,
    '& .MuiChip-label': { color: colors.color },
    ...extra,
  };
};
